import { animate, motion, useMotionValue, useTransform } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

import { ACCENT_CYAN } from '../constants';

export function LivePingBadge() {
  const count = useMotionValue(180);
  const rounded = useTransform(count, (v) => Math.round(v));
  const [displayValue, setDisplayValue] = useState(180);
  const [countdownDone, setCountdownDone] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const unsubscribe = rounded.on('change', (v) => setDisplayValue(v));
    return unsubscribe;
  }, [rounded]);

  useEffect(() => {
    const controls = animate(count, 3, {
      duration: 3,
      ease: 'easeOut',
      onComplete: () => setCountdownDone(true),
    });
    return controls.stop;
  }, [count]);

  useEffect(() => {
    if (!countdownDone) return undefined;

    const oscillate = () => {
      const next = Math.floor(Math.random() * 5) + 1;
      animate(count, next, { duration: 0.4, ease: 'easeInOut' });
    };

    oscillate();
    intervalRef.current = setInterval(oscillate, 1200);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [countdownDone, count]);

  const getPingColor = () => {
    if (displayValue > 100) return '#FF4444';
    if (displayValue > 50) return '#FFB800';
    return ACCENT_CYAN;
  };
  const pingColor = getPingColor();

  return (
    <motion.span className='font-mono text-3xl font-black tabular-nums' style={{ color: pingColor }}>
      {displayValue}
      <span className='text-[0.4em] font-normal opacity-60'>ms</span>
    </motion.span>
  );
}
